import { LinkModal } from "./LinkModal";
import { BubbleMenu } from "@tiptap/react";
import { Editor } from '@tiptap/core'
import { useLinkContext } from "../../hooks/useLinkContext";


// Extracted from : https://codesandbox.io/s/tiptap-react-ts-simple-text-editor-hcyp3l?file=/src/styles.css
type LinkEditorProps = {
    editor: Editor
}

export const LinkEditor = ({editor } : LinkEditorProps) => {

    const context = useLinkContext()

    return (
        <>
            <LinkModal
                url={context.url}
                isOpen={context.modalIsOpen}
                onRequestClose={context.closeModal}
                contentLabel="Modal d'edició d'enllaços"
                closeModal={context.closeModal}
                onChangeUrl={(e) => context.setUrl(e.target.value)}
                onSaveLink={context.saveLink}
                onRemoveLink={context.removeLink}
            />
            <BubbleMenu
                className="link-edit-container"
                tippyOptions={{ duration: 150 }}
                editor={editor}
                shouldShow={({ editor, from, to }) => {
                    // only show the bubble menu for links.
                    return from === to && editor.isActive("link");
                }}
            >
                <button className="bt bt-basic bt-basic-petit bt-basic-vermell" onClick={context.openModal}>
                Edita
                </button>
                <button className="bt bt-basic bt-basic-petit" onClick={context.removeLink}>
                Suprimeix
                </button>
            </BubbleMenu>
        </>
        
    ) 
}
